
import Phase from './Phase'

export default function ProgressCard({phaseName, phaseValue, progressState}) {
  return (
    <div key={`progressCard_${phaseValue}_state_${progressState}`} className='progressCard'>
        <h4 className='progress_header'>{phaseName}</h4>
        <Phase phaseValue={phaseValue} progressState={progressState}/>
    </div>
  )
}
